import { render, staticRenderFns } from "./ToogleSwitch.vue?vue&type=template&id=15c0b0d5&scoped=true&"
import script from "./ToogleSwitch.vue?vue&type=script&lang=js&"
export * from "./ToogleSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ToogleSwitch.vue?vue&type=style&index=0&id=15c0b0d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c0b0d5",
  null
  
)

export default component.exports